<template>
  <div>
    <v-container fluid class="pa-0">
      <b-navbar id="survey-nav" class="nav-banner bannerX" fixed="top">

        <!-- ROW 1 -->
        <v-layout row wrap align-center class="nav-row1 px-2">

          <!-- LEFT: NSF Title -->
          <v-flex xs12 lg5 class="d-flex align-center">
            <img
              class="logo_brand mr-2"
              src="../assets/NSF_Logo_flat.png"
              width="25"
              height="25"
              alt="NSF Logo"
            />
            <div class="banner-text-row1-bold">
              U.S. National Science Foundation Survey of Federal Funds for Research and Development
            </div>
          </v-flex>

          <!-- MIDDLE: Last Saved -->
          <v-flex xs12 sm6 md4 lg3>
            <div class="nav-saved-info">
              Last saved
              <v-progress-circular
                v-if="showSaveSpinner"
                indeterminate
                color="light-blue"
                size="16"
                width="2"
              />
              &nbsp;{{ lastSavedTimeStamp }}
              <span v-if="lastUpdated.name">
                ({{ lastUpdated.name }})
              </span>
            </div>
          </v-flex>

          <!-- RIGHT: Office Info -->
          <v-flex xs12 sm6 md8 lg4 class="d-flex justify-end">
            <div class="office-name banner-text-row1">
              {{ officeDescription }} {{ sequenceNumber }} {{ departmentType }}
            </div>
          </v-flex>

        </v-layout>

        <!-- ROW 2 -->
        <v-layout row wrap align-center class="nav-row2 py-1">

          <!-- LEFT: FY Volume -->
          <v-flex lg3 class="text-left pl-4">
            <div class="survey-years">{{ FYVolume }}</div>
          </v-flex>

          <v-spacer />

          <!-- RIGHT: Buttons -->
          <v-flex lg9>
            <v-layout row align-center justify-end pr-4>

              <v-btn class="button button-spacer" @click="landing" depressed>
                <v-img class="button-img" width="16" height="16" :src="require('../assets/home.png')" />
                Home
              </v-btn>

              <!--<v-btn class="button button-spacer" @click="printWindow">
                <v-img class="button-img" width="16" height="16" :src="require('../assets/print.png')" />
                Download
              </v-btn>-->

              <v-btn class="button button-spacer" @click="collapseAll">
                <v-img class="button-img" width="16" height="16" :src="require('../assets/collapse-all.png')" />
                Collapse all Questions
              </v-btn>

              <v-btn :class="isSurveyLocked" @click="surveysubmit" :disabled="isSubmitEnabled">
                <v-img class="button-img" width="16" height="16" :src="require('../assets/submit-survey.png')" />
                Submit Survey
              </v-btn>

              <div class="logout-block ml-4" tabindex="0">
                <a class="sign-out banner-text-row1" href="#" @click="logout">Sign Out</a>
              </div>

            </v-layout>
          </v-flex>

        </v-layout>

      </b-navbar>
    </v-container>

    <!-- Spacer so content doesn't hide under fixed navbar -->
    <div style="height: 90px"></div>
  </div>
</template>

<script>
import { authTokenService } from "@/services/authTokenService.js";
import { authService } from "@/services/authService.js";
import router from "@/router";
import { officeManagementService } from "@/services/officeManagementService.js";
import { surveyService } from '@/services/surveyService.js';
import { userService } from "@/services/userService.js";

export default {
  name: "NavBarSurvey",
  components: {},
  props: {},
  data: () => ({
    officeDescription: "",
    lastUpdated: {
      name: null,
      date: null,
      byMe: false
    },
    isHidden: true,
    exitUser: null,
    isLocked: false,
    isSurveyLocked: null,
    departmentType: null,
    sequenceNumber: null,
    FYVolume: null
  }),
  methods: {

     setIsLocked: function () {
      const me = this;
      me.activeId = authTokenService.getActiveSurveyId();
        surveyService.getLockStatus(me.activeId).then(function (response) {
          if (response && response.data != null) {
            // eslint-disable-next-line eqeqeq
            if (response.data.isLocked == true) {
                me.isLocked = true;
                me.isSurveyLocked = "isDisabled";
                // me.lockMessage = "Note: This survey has been sumitted and locked."
            } else if (response.data.currentUser != null) {
              me.isLocked = true;
              // me.lockMessage = `The survey is in use by user: ${response.data.currentUser}`;
            } else {
      me.isLocked = false;
			me.isSurveyLocked = null;
              // me.isLocked = me.disableInCaseOfPreviousVolume();
            }
          }
        })
        .catch(function (e) {
          console.log(e);
          console.log('Error loading survey lock status')
          throw e;
        });
        console.log("FromQuestion", me.isLocked);
        return me.isLocked;
      },
      // In case of previous volume need to disable
	disableInCaseOfPreviousVolume: function () {
			debugger;
			const me = this;
			const cVolume = authTokenService.getCurrentVolume();
			userService.getVolumeConfig().then(function (response) {
			if (response && response.data != null) {
				if (response.data.volume !== cVolume) {
					me.isLocked = true;
					me.isSurveyLocked = "isDisabled";
				} else {
					me.isLocked = false;
					me.isSurveyLocked = "";
				}
			}
		});
		return me.isLocked;
	},
		clearCache () {
			location.reload();
		},
		logout () {
			const me = this;
			me.activeId = authTokenService.getActiveSurveyId();

			surveyService.setCurrentUser(me.activeId, false).then(function (response) {
				if (response && response.data != null) {
					console.log("Current user has been unset");

					authService.logout();
					me.clearCache(); // <-- FIXED
				}
			})
			.catch(function (e) {
				console.log(e);
				console.log("Couldn't unset current user");
				throw e;
			});
		},
    admin () {
      router.push({ name: "admin" });
    },
    officemanagement () {
      router.push({ name: "officemanagement" });
    },
    doNothing () {
      console.log("top nav bar button clicked");
    },
    unavailable_ () {
      router.push({ name: "unavailable_" });
    },
		landing () {
			const me = this;
			me.activeId = authTokenService.getActiveSurveyId();
			surveyService.setCurrentUser(me.activeId, false).then(function (response) {
				if (response && response.data != null) {
					console.log("Current user has been unset");

					router.push({ name: "landing" });
				}
			})
			.catch(function (e) {
				console.log(e);
				console.log('Couldn\'t unset current user');
				throw e;
			});
    },
    surveysubmit () {
      console.log(this.isSurveyLocked);
      if (this.isSurveyLocked == null) {
        router.push({ name: "surveysubmit" });
      }
    },
    collapseAll () {
      this.$emit("collapse");
    },
    saveAll () {
      this.$store.dispatch("saveAll");
    },
    printWindow: function () {
			window.print();
    }
  },
  mounted () {
    const me = this;
    const activeId = authTokenService.getActiveSurveyId();
    me.isLocked = me.setIsLocked();
    me.FYVolume = authTokenService.getFYVolume();
    if (me.FYVolume == null) {
      me.FYVolume = "FYs 2025-26 (Volume 75)";
    }
    officeManagementService
      .getOfficeBySurveyId(activeId)
      .then(function (response) {
        if (response && response.data) {
          console.log("response.data For Office", response.data);
          var offName = response.data.officeName;
          var nameLen = offName.length;
          var nameMax = 40;
          if (nameLen > nameMax) {
            var endLen = 10; // text to show after ellipsis
            var frontStr = offName.substring(0, nameMax - (endLen + 1));
            var endStr = offName.substring(nameLen - (endLen + 1), nameLen);
            offName = frontStr.trim() + "..." + endStr;
          }
          me.officeDescription = offName;
          me.sequenceNumber = "(" + response.data.agency + "-" + response.data.program+"-"+response.data.field+"-"+response.data.branch+")";
          if (response.data.agency != "00000" && response.data.program == "00000" && (response.data.field == "00000" || response.data.field == "0000" || response.data.field == "000") && (response.data.branch == "00000" || response.data.branch == "0000" || response.data.branch == "000")) {
            me.departmentType = "(Agency)";
          } else if (response.data.agency != "00000" && response.data.program != "00000" && (response.data.field == "00000" || response.data.field == "0000" || response.data.field == "000") && (response.data.branch == "00000" || response.data.branch == "0000" || response.data.branch == "000")) {
            me.departmentType = "(Program)";
          } else if (response.data.agency != "00000" && response.data.program != "00000" && (response.data.field != "00000" || response.data.field != "0000" || response.data.field != "000") && (response.data.branch == "00000" || response.data.branch == "0000" || response.data.branch == "000")) {
            me.departmentType = "(Field)";
          } else {
            me.departmentType = "(Branch)";
          }

          if (response.data.id != null) {
            officeManagementService.getSurveyByOfficeId(response.data.id).then(function (resp) {
              me.lastUpdated.name = resp.data.updateBy;
              me.lastUpdated.date = (resp.data.updateDate) ? resp.data.updateDate : me.$store.getters["lastSavedTimeStamp"];
              if (me.lastUpdated.name) {
                let claims = authTokenService.getClaims();
                me.lastUpdated.byMe = (claims.userName.toLowerCase() === me.lastUpdated.name.toLowerCase());
              }
            })
            .catch(function (err) {
              console.log(err);
              console.log("Error loading survey status in survey page");
              throw err;
            });
          }
        }
      });
  },
  computed: {
    isSubmitEnabled () {
      const me = this;
      me.isLocked = this.setIsLocked();
      // let surveyStatus = this.$store.getters["validation/surveyStatus"];
      // return surveyStatus === CONSTANTS.SURVEY_STATUS.COMPLETE;
      return me.isLocked;
    },
    lastSavedTimeStamp () {
      var lastSavedTime = this.$store.getters["lastSavedTimeStamp"];
      var lastSaved;
      if (lastSavedTime != null) {
        // Removes seconds from saved date (too detailed and shortens to avoid forcing header to 2 lines)
        var nSec = lastSavedTime.lastIndexOf(":");
        if (nSec > 0) {
          lastSavedTime = lastSavedTime.substring(0, nSec);
          lastSaved = "Question: " + this.$store.getters["questionId"]  + " saved at: "+ lastSavedTime;
        } else {
          lastSaved = lastSavedTime;
        }
      }
      return lastSaved;
    },
    showSaveSpinner () {
      return this.$store.getters["isSaving"];
    }
  },
	created () {
		window.addEventListener('beforeunload', this.logout)
	}
};
</script>

<style scoped>
.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fullscreen {
  z-index: -1;
}

.button-img {
  /* width: 16px;
  height: 16px;  Now setting sizes explicilty on v-btn bc this approach isn't working on Edge v45 (see Asana) */
  margin-right: 5px;
}
.button {
  margin-right: 20px;
  padding-left: 15px !important;
  padding-right: 15px !important;
  text-transform: capitalize;
}

/* disabled button, e.g., Submit Survey */
button.button.v-btn disabled {
  color: #bfbdbd !important;
  border: 1px solid #353535;
  border-color: black;
}

.button-spacer {
  margin-right: 50px;
}

/* disabled button, e.g., Submit Survey */
button.button.v-btn disabled {
  color: #bfbdbd !important;
  border: 1px solid #353535; /* WIP */
  border-color: black;
}

.banner-text-row1-bold {
  font-size: 13pt;
  font-weight: bold;
}

.nav-saved-info {
  font-size: 11pt;
  font-weight: normal;
  color: antiquewhite;
}

.survey-years {
  font-size: 10pt;
  color: #e3e3e3;
}

.v-btn {
  color: black !important;
  height: 20px !important;
  font-size: 10pt !important;
  background-color: #dae8ff !important;
}

/* to ensure button bar remains on one row on small laptop monitors */
@media (max-width: 1100px) {
  .button {
    margin-right: 10px;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .button-spacer {
    margin-right: 30px;
  }
}
</style>
